import { DisqualifyingReason } from "./DisqualifyingReason";

/** An object representing the final result of a contact. */
export class ContactResult {
  /** The unique identifier of the result. */
  id?: string;
  /** The appointment id that was created for the contact (if any). */
  appointmentId?: string;
  /** The id of the patient associated with the contact.
   * @remarks Intentionally using `customerId` instead of `patientId` to maintain consistency with the backend API.
   */
  customerId: string;
  /** The id of the lead associated with the contact. */
  leadId: string;
  /** The type enum indicating the disposition/circumstances of the result. */
  type: ContactResultType;
  /**
   * An object with keys of {@link DisqualifyingReason}.id and a value flag indicating if the reason is applied.
   * @see DisqualifyingReason
   */
  disqualifyingReasons: Record<string, boolean>;

  constructor(patientId: string, leadId: string, type: ContactResultType, appointmentId?: string) {
    this.appointmentId = appointmentId;
    this.customerId = patientId;
    this.leadId = leadId;
    this.type = type;
    this.disqualifyingReasons = {};
  }

  /** Modifies the provided contactResult by adding the provided disqualifying reason before returning the same object. */
  static AddDisqualifyingReason = (
    contactResult: ContactResult,
    disqualifyingReason: DisqualifyingReason
  ): ContactResult => {
    contactResult.disqualifyingReasons = { ...contactResult.disqualifyingReasons, [disqualifyingReason.id]: true };
    return contactResult;
  };
}

export enum ContactResultType {
  Booked = 2,
  ObxNonCandidateMedical = 33,
  ObxNonCandidateBmi = 34
}
